import { stat } from 'fs';
import { Status } from '../components/CheckStatus';

export const getStatus = (data: {
  applicationReceivedAt: string | null;
  hasAllResponses: boolean;
  approvalDate: string | null;
  isRenewal: boolean;
  isVerification: boolean;
  requestedDBS: Boolean;
  dbsExpiryDate: string | null;
  idExpiryDate: string | null;
}) => {
  let status: Status = 'created';

  if (!data.idExpiryDate) {
    status = 'id';
  }

  if (data.requestedDBS && !data.dbsExpiryDate) {
    status = 'dbs';
  }

  if (data.applicationReceivedAt) {
    status = 'application';
  }

  if (data.applicationReceivedAt && data.hasAllResponses) {
    status = 'responses';
  }

  if (data.isRenewal && !data.approvalDate) {
    status = 'renewalStart';
  }

  if (data.isRenewal && data.approvalDate) {
    status = 'renewalApproved';
  }

  if (!data.applicationReceivedAt) {
    status = 'created';
  }

  if (data.approvalDate) {
    status = 'approved';
  }

  if (data.isVerification) {
    if (data.approvalDate) {
      status = 'approved';
    } else {
      status = 'manualVerification';
    }
  }

  return status;
};

export const statusText = {
  created: 'Application sent to delegate',
  application: 'Awaiting reference responses',
  responses: 'Awaiting final approval',
  approved: 'Approved',
  renewalStart: 'Renewal in progress',
  renewalApproved: 'Approved',
  manualVerification: 'Sent for manual verification',
  dbs: 'Awaiting DBS',
  id: 'Awaiting ID verification'
};
